import React from 'react';

import FieldOptionGroup from '../components/FieldOptionGroup/FieldOptionGroup';
import FieldSearchableSelect from '../components/FieldSearchableSelect/FieldSearchableSelect';
import FieldCheckboxGroup from '../components/FieldCheckboxGroup/FieldCheckboxGroup';
import {
  CHIP_LIMIT,
  getOptionControlMode,
  OPTION_CONTROL_SEARCHABLE,
} from '../config/listingOptionControls';

/**
 * Render a single-select option field using segmented / chips / searchable.
 */
export const renderSingleOptionField = ({
  id,
  name,
  label,
  helpText,
  options = [],
  isRequired,
  validate,
  onChange,
  className,
  placeholder,
  layout,
  searchPlaceholder,
  chipLimit = CHIP_LIMIT,
}) => {
  if (!options.length) {
    return null;
  }

  const mode = getOptionControlMode(options.length, chipLimit);

  if (mode === OPTION_CONTROL_SEARCHABLE) {
    return (
      <FieldSearchableSelect
        id={id}
        name={name}
        label={label}
        helpText={helpText}
        options={options}
        isRequired={isRequired}
        validate={validate}
        onValueChange={onChange}
        className={className}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
      />
    );
  }

  return (
    <FieldOptionGroup
      id={id}
      name={name}
      label={label}
      helpText={helpText}
      options={options}
      isRequired={isRequired}
      validate={validate}
      onChange={onChange}
      className={className}
      layout={layout}
      chipLimit={chipLimit}
    />
  );
};

/**
 * Render a multi-select option field as chips (or checkbox group for long lists).
 */
export const renderMultiOptionField = ({
  id,
  name,
  label,
  helpText,
  options = [],
  isRequired,
  validate,
  className,
  chipLimit = CHIP_LIMIT,
}) => {
  if (options.length > 0 && options.length <= chipLimit) {
    return (
      <FieldOptionGroup
        id={id}
        name={name}
        label={label}
        helpText={helpText}
        options={options}
        isRequired={isRequired}
        validate={validate}
        className={className}
        chipLimit={chipLimit}
        multiple
      />
    );
  }

  return (
    <FieldCheckboxGroup
      id={id}
      name={name}
      label={label}
      helpText={helpText}
      options={options}
      isRequired={isRequired}
      validate={validate}
      className={className}
    />
  );
};
